import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import {connect} from "trim-redux";
import Grid from "@material-ui/core/Grid/Grid";
import {Translate} from "../../../../config/Translate";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import TextField from "@material-ui/core/TextField/TextField";
import SearchIcon from '@material-ui/icons/Search';
class MainSearch extends React.Component {

    classes = this.props.classes
    state={
        search: '',
    };
    componentDidMount(){
        this.setState({
            search: this.props.code,
        })
    }
    track(){
        let {search} = this.state;
        this.props.history.push(`/track/${search}`);

    }
    render() {
        return (
            <Grid container spacing={2}  style={{margin:"10px 0"}}>
                <Grid item xs={11}>
                    <TextField
                        fullWidth
                        name="search"
                        variant={"outlined"}
                        label={Translate.orderTrackingCodeFull}
                        placeholder={Translate.searchForOrder}
                        value={this.state.search}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                <Tooltip title={Translate.search} arrow>
                                    <IconButton onClick={() => this.track()} color="primary">
                                        <SearchIcon />
                                    </IconButton>
                                </Tooltip>
                            </InputAdornment>,
                        }}
                        onChange={(e) => this.setState({
                            search: e.target.value
                        })}
                        type="text"
                    />
                </Grid>
            </Grid>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(MainSearch))));